"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELogLevel = exports.EServiceNames = exports.MAX_AMOUNT_NOTE_POST = exports.MAX_AMOUNT_NOTE_PRE = exports.GENERIC_NOTE = exports.FORM_COMPLETED = exports.BLOCKED_SSN = exports.PREQUALIFIED = exports.NOT_PREQUALIFIED = exports.FORM_NOT_COMPLETED = exports.CHANNEL_TYPE_HOT_LEAD = exports.CHANNEL_TYPE = exports.PREQUAL_RESPONSE_TYPE = exports.EErrorCodes = exports.EloquaFormsKeys = exports.ConsentTypes = exports.EApplicationSteps = exports.CONSUMER_ERRORS = exports.CONSUMER_NAMES = exports.EApplicationStatus = void 0;
var EApplicationStatus;
(function (EApplicationStatus) {
    EApplicationStatus["ACTIVE"] = "ACTIVE";
    EApplicationStatus["PREQUALIFIED"] = "PREQUALIFIED";
    EApplicationStatus["CAPS_PREQUALIFIED"] = "CAPSPREQUALIFIED";
    EApplicationStatus["QUEUED"] = "QUEUED";
    EApplicationStatus["COMPLETED"] = "COMPLETED";
    EApplicationStatus["OPEN_LOAN"] = "OPEN_LOAN";
    EApplicationStatus["FROZEN_BUREAU"] = "FROZEN_BUREAU";
    EApplicationStatus["INVALID"] = "INVALID";
    EApplicationStatus["INVALID_SSN"] = "INVALID_SSN";
    EApplicationStatus["SERVER_ERROR"] = "SERVER_ERROR";
    EApplicationStatus["BLOCKED_SSN"] = "BLOCKED_SSN";
    EApplicationStatus["ABANDONED"] = "ABANDONED";
})(EApplicationStatus || (exports.EApplicationStatus = EApplicationStatus = {}));
var CONSUMER_NAMES;
(function (CONSUMER_NAMES) {
    CONSUMER_NAMES[CONSUMER_NAMES["abandonPrequalified"] = 0] = "abandonPrequalified";
    CONSUMER_NAMES[CONSUMER_NAMES["consumerEmail"] = 1] = "consumerEmail";
    CONSUMER_NAMES[CONSUMER_NAMES["dealerCaps"] = 2] = "dealerCaps";
    CONSUMER_NAMES[CONSUMER_NAMES["dealerRefferal"] = 3] = "dealerRefferal";
    CONSUMER_NAMES[CONSUMER_NAMES["hotLead"] = 4] = "hotLead";
    CONSUMER_NAMES[CONSUMER_NAMES["dealerContact"] = 5] = "dealerContact";
})(CONSUMER_NAMES || (exports.CONSUMER_NAMES = CONSUMER_NAMES = {}));
var CONSUMER_ERRORS;
(function (CONSUMER_ERRORS) {
    CONSUMER_ERRORS[CONSUMER_ERRORS["error"] = 0] = "error";
    CONSUMER_ERRORS[CONSUMER_ERRORS["processing_error"] = 1] = "processing_error";
    CONSUMER_ERRORS[CONSUMER_ERRORS["timeout_error"] = 2] = "timeout_error";
})(CONSUMER_ERRORS || (exports.CONSUMER_ERRORS = CONSUMER_ERRORS = {}));
var EApplicationSteps;
(function (EApplicationSteps) {
    EApplicationSteps["ONE"] = "1";
    EApplicationSteps["TWO"] = "2";
    EApplicationSteps["THREE"] = "3";
    EApplicationSteps["FOUR"] = "4";
    EApplicationSteps["FIVE"] = "5";
    EApplicationSteps["SIX"] = "6";
})(EApplicationSteps || (exports.EApplicationSteps = EApplicationSteps = {}));
var ConsentTypes;
(function (ConsentTypes) {
    ConsentTypes["OSM_EMAIL_PHONE"] = "OSM_EMAIL_PHONE";
    ConsentTypes["OSM_SSN"] = "OSM_SSN";
    ConsentTypes["OSM_CREDIT_AUTH"] = "OSM_CREDIT_AUTH";
    ConsentTypes["PRODUCT_TERMS"] = "PRODUCT_TERMS";
    ConsentTypes["EMAIL_DISCLOSURE"] = "EMAIL_DISCLOSURE";
    ConsentTypes["OSM_CREDIT_AUTH_OSM_SSN"] = "OSM_CREDIT_AUTH/OSM_SSN";
})(ConsentTypes || (exports.ConsentTypes = ConsentTypes = {}));
var EloquaFormsKeys;
(function (EloquaFormsKeys) {
    EloquaFormsKeys["ABANDON_PREQUALIFIED"] = "abandonPrequalified";
    EloquaFormsKeys["CONSUMER_EMAIL"] = "consumerEmail";
    EloquaFormsKeys["DEALER_CAPS"] = "dealerCaps";
    EloquaFormsKeys["DEALER_REFFERALS"] = "dealerRefferals";
})(EloquaFormsKeys || (exports.EloquaFormsKeys = EloquaFormsKeys = {}));
var EErrorCodes;
(function (EErrorCodes) {
    EErrorCodes["NOT_AUTHORIZED"] = "Not Authorized";
})(EErrorCodes || (exports.EErrorCodes = EErrorCodes = {}));
var PREQUAL_RESPONSE_TYPE;
(function (PREQUAL_RESPONSE_TYPE) {
    PREQUAL_RESPONSE_TYPE["GENERIC"] = "Generic";
    PREQUAL_RESPONSE_TYPE["MONTHLY_PAYMENT"] = "Monthly_Payment";
})(PREQUAL_RESPONSE_TYPE || (exports.PREQUAL_RESPONSE_TYPE = PREQUAL_RESPONSE_TYPE = {}));
exports.CHANNEL_TYPE = "CONSUMER - OSM PREQUALIFICATION";
exports.CHANNEL_TYPE_HOT_LEAD = "CONSUMER - OSM HOT LEAD";
exports.FORM_NOT_COMPLETED = "N";
exports.NOT_PREQUALIFIED = "N";
exports.PREQUALIFIED = "Y";
exports.BLOCKED_SSN = "B";
exports.FORM_COMPLETED = "Y";
exports.GENERIC_NOTE = 'This consumer has been pre-qualified through Credit Acceptance. To complete the approval process, please submit a credit application for a specific vehicle.';
exports.MAX_AMOUNT_NOTE_PRE = 'This consumer has been pre-qualified for a monthly payment of up to $';
exports.MAX_AMOUNT_NOTE_POST = ' through Credit Acceptance. The pre-qualification is valid for 30 days from the date of this note. To complete the approval process, please submit a credit application for a specific vehicle.';
var log_constants_1 = require("./log-constants");
Object.defineProperty(exports, "EServiceNames", { enumerable: true, get: function () { return log_constants_1.EServiceNames; } });
Object.defineProperty(exports, "ELogLevel", { enumerable: true, get: function () { return log_constants_1.ELogLevel; } });
